import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import allReducers from './reducers';
import signalRMiddleware from './GameHub/signalRMiddleware';

const initialState = {};

const middleware = [thunk];

const store = createStore(
    allReducers,
    initialState,
    compose(
        applyMiddleware(...middleware, signalRMiddleware),
        //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
);

export default store;